import PromiseRequest from "../../../../req/PromiseRequest";
import {IFormTemplate, IRouteDefinitionParams} from '../../../../index';
import {createErrorMessage} from "../../../../util/misc";
import {global} from "../../../../appContext";
import {template as tpl, viewModel as MutableViewModel} from "../mutable/details";
import {CREATING_MESSAGE} from "../../../../constants/Language";
import {setRouteHash} from "../../../../constants/RouteDefinitions";

export let template = tpl;

export class viewModel extends MutableViewModel {
    protected readonly reqSubmit: PromiseRequest = new PromiseRequest('createformtemplate');

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.kosub.subscribe(global.login.selectedOrganization, this.init.bind(this));
        this.data = {
            active: false,
            authenticationtypes: 0,
            availableto_id: 0,
            companyid: global.login.selectedOrganizationId() ?? '',
            id: 0,
            messages: [],
            name: '',
            pages: [],
            published: false,
        }
        this.init();
    }

    protected override init(): Promise<any> {
        return super
            .init()
            .then(() => {
                this.name(this.data.name);
                this.authenticationTypes([]);
                this.active(this.data.active);
                this.published(this.data.published);
                this.pages([]);
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            });
    }

    /*******************************************************************************************************************
     * Submit
     ******************************************************************************************************************/

    protected onSubmit() {
        const data = this.getSubmitData();
        const jformtemplate = encodeURIComponent(JSON.stringify(data));

        this.isReady(false);
        this.messageData({message: CREATING_MESSAGE});
        this.reqSubmit.abort();
        this.reqSubmit
            .request({
                jformtemplate: jformtemplate,
            })
            .then((data: IFormTemplate[]) => {
                const template = data[0];
                if (!template) {
                    return;
                }
                global.snackbarData({message: 'subject is created|s:((form template))'});
                global.cacheManager.removeCache('getformtemplate');
                global.cacheManager.removeCache('searchformtemplate');
                global.cacheManager.removeCache('getehubprocess');
                setRouteHash('formtemplatedetails', {id: template.id});
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
                this.isReady(true);
            });
    }

}
